module.exports = __webpack_public_path__ + "img/icon-generic-entrance.0a935df9.svg";